import type { PropsWithChildren } from 'react'

import { AuthHeroPanel } from '@/features/auth/components/AuthHeroPanel'
import { SplitAuthLayout } from '@/shared/components/patterns/SplitAuthLayout'

type AuthFlowLayoutProps = PropsWithChildren<{
  mode?: 'split' | 'centered' | 'wide'
}>

export function AuthFlowLayout({ children, mode = 'split' }: AuthFlowLayoutProps) {
  return (
    <div className="relative">
      <SplitAuthLayout
        hero={mode === 'split' ? <AuthHeroPanel /> : undefined}
        mode={mode}
      >
        {children}
      </SplitAuthLayout>
    </div>
  )
}
